import { ReportMedia } from "@shared/lib/types/reports";
import { formatData } from "@shared/lib/utils/formatData";
import { Col, Flex, Progress, Row, Typography } from "antd";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import styles from "./styles.module.scss";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  ChartDataLabels,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const { Title, Text } = Typography;

export function RepoerMeidaCommentAnalysis({ media }: { media: ReportMedia }) {
  if (!media.commentData) {
    return null;
  }
  return (
    <div>
      <Title level={3}> Comment Ananlysis</Title>
      <Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
        <Col span={10}>
          <div>
            <div style={{ width: "300px", height: "300px" }}>
              <Doughnut
                options={{
                  cutout: "75%", // Reduced cutout for a thicker doughnut appearance
                  plugins: {
                    legend: { position: "bottom", align: "end" },
                    datalabels: {
                      font: {
                        size: 22, // Adjust text size
                        weight: "bold",
                      },
                      anchor: "center",
                      align: "start",
                      offset: 45,
                      textAlign: "center",
                      formatter: (value, context) => {
                        // Only display text for the first segment (Relevant Comments)
                        if (context.dataIndex === 0) {
                          return ` ${value}% \n Relevant`; // Or any other text you want
                        }
                        return null; // Don't display labels on other segments
                      },
                    },
                  },
                }}
                data={{
                  labels: [
                    `Relevant Comments ${formatData(
                      (media.commentData.noOfRevelantComment /
                        (media.commentData.noOfCommentsAnalysed || 1)) *
                        100,
                      "0.00"
                    )}% `,
                    `Irrelevant Comments ${formatData(
                      (1 -
                        media.commentData.noOfRevelantComment /
                          (media.commentData.noOfCommentsAnalysed || 1)) *
                        100,
                      "0.00"
                    )}%`,
                  ],
                  datasets: [
                    {
                      data: [
                        (
                          (media.commentData.noOfRevelantComment /
                            (media.commentData.noOfCommentsAnalysed || 1)) *
                          100
                        ).toFixed(2),
                        (
                          (1 -
                            media.commentData.noOfRevelantComment /
                              (media.commentData.noOfCommentsAnalysed || 1)) *
                          100
                        ).toFixed(2),
                      ],
                      backgroundColor: [
                        "rgb(4, 219, 142)",
                        "rgba(0, 0, 0, 0.06)",
                      ],
                      borderWidth: 1,
                      borderJoinStyle: "round",
                      borderRadius: 10,
                      hoverOffset: 4,
                      offset: 0,
                    },
                  ],
                }}
              />
            </div>
            <Title level={5}>Relevant Comments</Title>
            <Text type="secondary">
              {media.commentData.noOfRevelantComment} /{" "}
              {media.commentData.noOfCommentsAnalysed} comments
            </Text>
            <Text type="secondary">
              Comments relevant to what the creator is talking about in their
              post.
            </Text>
          </div>
        </Col>
        <Col span={10}>
          <div>
            <div style={{ width: "300px", height: "300px" }}>
              <Doughnut
                options={{
                  cutout: "75%", // Reduced cutout for a thicker doughnut appearance
                  plugins: {
                    legend: { position: "bottom", align: "end" },
                    datalabels: {
                      anchor: "start", // Changed from 'start' to 'end' for label positioning
                      align: "start",
                      font: {
                        size: 16,
                        style: "normal",
                      },
                    },
                  },
                }}
                data={{
                  labels: [
                    `Positive Comments(${
                      media.commentData.noOfPostiveComment
                    }) ${formatData(
                      (media.commentData.noOfPostiveComment /
                        (media.commentData.noOfCommentsAnalysed || 1)) *
                        100,
                      "0.00"
                    )}% `,
                    `Neutral Comments(${
                      media.commentData.noOfNeutralComment
                    }) ${formatData(
                      (media.commentData.noOfNeutralComment /
                        (media.commentData.noOfCommentsAnalysed || 1)) *
                        100,
                      "0.00"
                    )}% `,
                    `Negative Comments(${
                      media.commentData.noOfNegativeComment
                    }) ${formatData(
                      (media.commentData.noOfNegativeComment /
                        (media.commentData.noOfCommentsAnalysed || 1)) *
                        100,
                      "0.00"
                    )}% `,
                  ],
                  datasets: [
                    {
                      data: [
                        (
                          (media.commentData.noOfPostiveComment /
                            (media.commentData.noOfCommentsAnalysed || 1)) *
                          100
                        ).toFixed(2),
                        (
                          (media.commentData.noOfNeutralComment /
                            (media.commentData.noOfCommentsAnalysed || 1)) *
                          100
                        ).toFixed(2),
                        (
                          (media.commentData.noOfNegativeComment /
                            (media.commentData.noOfCommentsAnalysed || 1)) *
                          100
                        ).toFixed(2),
                      ],
                      backgroundColor: [
                        "rgb(4, 219, 142)",
                        "rgba(0, 0, 0, 0.06)",
                        "#FF6384",
                      ],
                      borderWidth: 1,
                      borderJoinStyle: "round",
                      borderRadius: 10,
                      hoverOffset: 4,
                      offset: 0,
                    },
                  ],
                }}
              />
            </div>
            <Title level={5}>Audience Sentiment</Title>

            <Text type="secondary">
              Comments classified on the basis of the opinions and emotions
              behind them.
            </Text>
          </div>
        </Col>
        <Col span={10} className={styles.progressContainer}>
          <Progress
            type="dashboard"
            // className={styles.customDashboardProgress}
            size={"default"}
            rootClassName={styles.customDashboardProgress}
            format={(percent) => (
              <div className={styles.containerText}>
                <Title level={5} style={{ margin: 0 }}>
                  {percent}
                  {"% "}
                </Title>
                <Text type="secondary">{"Interested"} </Text>
              </div>
            )}
            percent={
              Number(
                (
                  media.commentData.noOfIntentToBuy /
                  (media.commentData.noOfCommentsAnalysed || 1)
                ).toFixed(2)
              ) * 100
            }
          />
          <Title level={5}>Intent to buy product</Title>
          <Text type="secondary">
            {media.commentData.noOfIntentToBuy} /{" "}
            {media.commentData.noOfCommentsAnalysed} comments
          </Text>
          <Text type="secondary">
            Comments in which people have shown intent to buy the
            product/service.
          </Text>
        </Col>
      </Row>
    </div>
  );
}
